export default __webpack_public_path__ + "static/david-lloyd-logo-445f769d7b9a4b56392f297db0c9a302.png";